<template>
  <div v-cloak>
      
    <span v-if="this.$route.name == 'about'">

      <h3>About</h3>

      <p>
        Crypto Clothing mission is to simplify the lives of blockchain project founders and fans by providing ready-made high quality crypto merchandise products for hundreds of most popular crypto coins and tokens.
        <br><br>
        Merchandise images on the Crypto Clothing website were generated using high-quality cryptocurrency logos from <a href="https://cryptologos.cc" target="_blank">Crypto Logos</a>.
        <br><br>
        <!-- <b>Crypto Clothing items available on our website are for inspiration only, and not for sale!</b>
        <br><br> -->
      </p>

    </span>

    <span v-if="this.$route.name == 'terms-and-conditions'">
      
      <h3>Terms and Conditions</h3>

      <p>Last updated: November 12, 2023</p>

      <h4>1. Terms</h4>

      <p>These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and Crypto Clothing (“we,” “us” or “our”), concerning your access to and use of the https://cryptoclothing.cc web app as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the “Site”). You agree that by accessing the Site, you have read, understood, and agreed to be bound by all of these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY. </p>

      <p>Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms of Use at any time and for any reason. We will alert you about any changes by updating the “Last updated” date of these Terms of Use, and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Terms of Use to stay informed of updates. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by your continued use of the Site after the date such revised Terms of Use are posted.&nbsp;</p>

      <p>The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.</p>

      <h4>2. The service</h4>

      <p>Crypto Clothing offers a streamlined solution for ordering brand promotional merchandise, simplifying the entire process for our users.</p>

      <p>Our application facilitates an efficient ordering process by providing users with current and high-quality logo files, generating mockups, and offering pre-selected options for both clothing types and optimal cost-benefit models.</p>

      <p>For this service Crypto Clothing charges a fixed commision from every order. The commision is already included in all prices on this website.</p>

      <p>Users must be 18 years or older to use Crypto Clothing services.</p>

      <h4>3. Use of copyrighted materials</h4>

      <p>Crypto Clothing neither owns nor claims any copyrights associated with the cryptocurrency logos displayed on our site. The copyrights for these logos are owned by their respective owners.</p>

      <p>Most of products available at Crypto Clothing are being used according to the fair-use principle or official branding guidelines of individual crypto projects. We recognize that these projects often encourage community engagement and the use of their logos for promotional purposes.</p>
      
      <p>In the case of highly decentralized projects like Bitcoin or Dogecoin, where there is no single owner, the use of logos is considered open and free for all.</p>

      <p>When you order a product featuring a specific coin's logo, please ensure that you use it according to the official logo usage guidelines. We trust our users to be aware of and adhere to the policies governing logo usage, as it is their responsibility to do so.</p>

      <p>If you are a representative of a crypto project and you believe that your logo is being used in a way that is not in accordance with your project's branding guidelines, please contact us and we will remove the logo from our website as soon as possible.</p>

      <h4>4. Privacy</h4>

      <p>Please review our Privacy Policy, which also governs your visit to our website, to understand our practices.</p>

      <h4>5. Production & Shipping</h4>

      <p>Our partner Printful takes care of the production and shipping. With more than 17 million delivered orders, Printful provides a top of the class order fulfillment service.</p>

      <p>Shipping is wordlwide.</p>

      <p>The fixed base shipping fee is <b>10 USD</b> for regular international shipping with tracking. Every item's shipping is <b>+2 USD</b>. For hoodies and sweatshirts, every item's shipping is +4 USD. For mugs it's +5 USD. The final sum is shown in your shopping cart before the checkout.</p>

      <p>Clothing production is done “on demand” – after the user makes an order. The average production time is 3 days.</p>

      <p>After production is complete, regular shipping takes around 5-15 days.</p>

      <h4>6. Returns and refunds</h4>

      <p>Because each order is individual, we cannot change them to other products. It means we do not accept returns and provide no refunds.</p>

      <p>In case the order was broken in transit or in any way not as described, we will change your item with a new one, in a timely manner, free of charge. In such situation, please contact us at &#105;n&#x66;o&#x40;c&#x72;y&#x70;&#116;&#x6f;&#99;&#x6c;&#111;&#x74;&#104;i&#110;g&#x2e;c&#x63;, include a photo of the item and a short description about the situation.</p>

      <p>In case our main service – ordering high quality crypto merchandise – was not fulfilled and it was a direct cause of Crypto Clothing application malfunctioning, we guarantee that all steps will be taken to ensure that the service will be fulfilled as soon as possible without any additional costs involved for our users.&nbsp; </p>

      <p>In cooperation with our partner Printful, we will do our best to provide a top quality order fulfillment service so that you could be perfectly happy with your order.</p>

      <h4>7. Limitations</h4>

      <p>In no event shall Crypto Clothing or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Crypto Clothing website, even if  Crypto Clothing or it’s authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you. </p>

      <h4>8. Accuracy of materials</h4>

      <p>The materials appearing on Crypto Clothing website could include technical, typographical, or photographic errors. Crypto Clothing does not warrant that any of the materials on its website are accurate, complete or current. Crypto Clothing may make changes to the materials contained on its website at any time without notice. However Crypto Clothing does not make any commitment to update the materials.<br><br>It is a sole responsibility of the user to double-check that the logo provided on the Crypto Clothing website is accurate and suits the individual need of the user.<br><br>Crypto Clothing does its best to provide the up to date and accurate logo collection for its products. However Crypto Clothing does not guarantee that the logos are 100% accurate or recent.</p>

      <p>If you have spotted an inaccurate or an old version of a logo, let us know by email and we will  update the logo as soon as possible.</p>

      <h4>9. Links</h4>

      <p>Crypto Clothing has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Crypto Clothing of the site. Use of any such linked website is at the user’s own risk.</p>

      <h4>10. Modifications</h4>

      <p>Crypto Clothing may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>

      <h4>11. Governing Law</h4>

      <p>These terms and conditions are governed by and construed in accordance with the laws of Lithuania and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>

    </span>

    <span v-if="this.$route.name == 'privacy-policy'">
      
      <h3>Privacy Policy</h3>

      <div style="height:5px;"></div>

      <p>Last updated: May 7, 2020</p>

      <p>Crypto Clothing operates https://cryptoclothing.cc (the “Site”). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site. </p>

      <p>Crypto Clothing is a privacy-focused service. The Personal Information of the user is never shared with third parties.</p>

      <p>If at some point Crypto Clothing, as a whole business, will be sold, the transfer of the Personal Information of Crypto Clothing users to the new business owner will be done under similar “privacy-oriented” conditions.</p>

      <p>We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.</p>

      <h4>Information Collection and Use</h4>

      <p>For all visitors of the Site we collect standard Cookies and Log Data, as described in the next sections.&nbsp;</p>

      <p>For payment processing, we use Stripe. When processing your payment, we never see your personal or payment details, as they are only collected by the Stripe service. For more details, please refer to the <a href="https://stripe.com/gb/privacy" target="_blank">Stripe privacy policy</a>.</p>

      <h4>Log Data</h4>

      <p>Like many site operators, we collect information that your browser sends whenever you visit our Site (“Log Data”).&nbsp;</p>

      <p>This Log Data may include information such as your computer’s Internet Protocol (“IP”) address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.&nbsp;</p>

      <p>In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this in order to provide user behavior insights and statistics for our website.</p>

      <h4>Cookies</h4>

      <p>Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer’s hard drive.&nbsp;</p>

      <p>Like many sites, we use “cookies” to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.</p>

      <h4>Security</h4>

      <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>

      <h4>Changes to This Privacy Policy</h4>

      <p>This Privacy Policy is effective as of Apr 23, 2019 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page. </p>

      <p>We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.&nbsp;</p>

      <p>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.</p>

      <h4>Contact Us</h4>

      <p>If you have any questions about this Privacy Policy, please contact us.</p>

    </span>


    <span v-if="this.$route.name == 'shipping'">
      
      <h3>Shipping</h3>

      <p>Crypto Clothing works together with <a href="https://www.printful.com/" target="_blank">Printful</a> which takes care of the production and shipping. With more than 17.3 million orders delivered, Printful provides the top of the class order fulfillment service.</p>

      <p>Shipping is worldwide.</p>

      <p>The base shipping price is <b>10 USD</b> for regular international shipping with tracking.</p>

      <p>Every item's shipping is <b>+2 USD</b>.</p>
      
      <p>For hoodies and sweatshirts, every item's shipping is +4 USD. For mugs it's +5 USD.</p>

      <p>You will see the final sum in your shopping cart before the checkout.</p>

      <p>All Crypto Clothing products are produced "on-demand" - the production starts after the order was placed. The average production time is 3 business days.</p>

      <p>After the production is complete, the shipping of your item(-s) takes around 5-10 days.</p>

      
      <h3>Returns</h3>

      <p>Since every Crypto Clothing product is made "on-demand" and is based on individual requirements, we do not offer size, color or model changes after the production is complete, and in general do not accept returns. Please refer to the sizing chart (available on every product's page) before finalizing your order.</p>

      <p>In case the package was broken in transit or a received product is somehow broken or not as described on the Crypto Clothing website, please contact us at &#105;n&#x66;o&#x40;c&#x72;y&#x70;&#116;&#x6f;&#99;&#x6c;&#111;&#x74;&#104;i&#110;g&#x2e;c&#x63;, include a photo of the item and a short description of the situation.</p>

      <p>Claims deemed an error on our part are covered at our expense. Any claims for misprinted/damaged/defective items must be submitted (contact us by email) within 2 weeks after the product has been received. For packages lost in transit, all claims must be submitted no later than 2 weeks after the estimated delivery date.</p>

      <p>You can find more details about each product on its individual page. For any additional questions, please contact us.</p>

    </span>
    <span v-if="this.$route.name == 'contacts'">
      
      <h3>Contacts</h3>
    
      <p>
        For any questions related to your order or the Crypto Clothing store in general, please contact us by email.
        <br><br>
        <b>&#105;n&#x66;o&#x40;c&#x72;y&#x70;&#116;&#x6f;&#99;&#x6c;&#111;&#x74;&#104;i&#110;g&#x2e;c&#x63;</b>
      </p>

      <div style="height:20px;"></div>

      <!-- <p>Follow us on Twitter by following <a href="https://twitter.com/cryptologoscc" target="_blank">Crypto Logos</a> -->

      <div class="desktop-only" style="height:50px;"></div>

    </span>


    <span v-if="this.$route.name == 'payment-success'">
      
      <h1>Payment successful</h1>

      <p>Thank you, we have received your order.</p>

    </span>


    <span v-if="this.$route.name == 'payment-declined'">

      <h1>Payment declined</h1>
      
      <p>Your payment was declined. You can try again. Please double-check the data you have entered, or use another card.</p>

    </span>

  </div>
</template>

<script>

export default {
  components: {

  },

  watch: {
    // $route (to, from){
      // if (to.name == 'about') {
      //   this.inner = "About";
      //   this.$emit('updateHead');
      // }
      // else if (to.name == 'privacy-policy') {
      //   this.inner = "Privacy Policy";
      //   this.$emit('updateHead');
      // }
      // else if (to.name == 'terms-and-conditions') {
      //   this.inner = "Terms and Conditions";
      //   this.$emit('updateHead');
      // }
      // else if (to.name == 'shipping') {
      //   this.inner = "Shipping";
      //   this.$emit('updateHead');
      // }
      // else if (to.name == 'contacts') {
      //   this.inner = "Contacts";
      //   this.$emit('updateHead');
      // }
      // else if (to.name == 'payment-success') {
      //   this.inner = "Payment Successful";
      //   this.$emit('updateHead');
      // }
      // else if (to.name == 'payment-declined') {
      //   this.inner = "Payment Declined";
      //   this.$emit('updateHead');
      // }
    // }
  },

  data() {
    return {
      // title: 'Loading...'
      inner: ''
    }
  },

  // head: {
  //   title: function () {
  //     return {
  //       inner: this.inner,
  //       separator: '-',
  //       complement: 'Crypto Clothing'
  //     }
  //   },
  // },

  mounted() {
    
    if (this.$route.name == "payment-success") {
      dexie.products.clear();
      this.$emit('countRefresh');
    }

    // if (this.$route.name == 'faq') {
    //   this.inner =  "FAQ";
    //   this.$emit('updateHead');
    // }
    // else if (this.$route.name == 'about') {
    //   this.inner =  "About";
    //   this.$emit('updateHead');
    // }
    // else if (this.$route.name == 'privacy-policy') {
    //   this.inner =  "Privacy Policy";
    //   this.$emit('updateHead');
    // }
    // else if (this.$route.name == 'terms-and-conditions') {
    //   this.inner =  "Terms and Conditions";
    //   this.$emit('updateHead');
    // }
    // else if (this.$route.name == 'shipping') {
    //   this.inner =  "Shipping";
    //   this.$emit('updateHead');
    // }
    // else if (this.$route.name == 'contacts') {
    //   this.inner =  "Contacts";
    //   this.$emit('updateHead');
    // }
    // else if (this.$route.name == 'payment-success') {
    //   this.inner =  "Payment Successful";
    //   this.$emit('updateHead');
    // }
    // else if (this.$route.name == 'payment-declined') {
    //   this.inner =  "Payment Declined";
    //   this.$emit('updateHead');
    // }

    // console.log('bump');
    // Object.entries(cc_coins).forEach(entry => {
    //   let id = entry[0];
    //   let name = entry[1];

    //   if (this.$route.params.coinId == id) {
    //     // console.log(id);
    //   }
    // });
    // console.log(this.$route);
  },
};
</script>

<style scoped>

  p { 
    font-size: 14px;
  }

  a {
    border-bottom: 1px solid grey;
  }
</style>